<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            <router-link :to="{ name: 'configuracion' }"> {{ $t('configuracion') }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            {{ tieneDimoni ? $t('importacionContable') : $t('importacionSage') }}
                        </li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-5">
                            <div class="form-group">
                                <label for="listBusiness"><strong>{{ $t("negocio") }}</strong></label>

                                <el-select class="select-default" size="large" v-model="idBusiness"
                                    v-on:change="cambiarNegocio()" filterable
                                    :placeholder="this.$i18n.t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses" class="select-primary"
                                        :value="business.id" :label="business.establishmentName" :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listTPV"><strong>{{ $t("TPV") }}</strong></label>

                                <el-select class="select-default" size="large" v-model="idTpv" v-on:change="cambiarTpv()"
                                    filterable :placeholder="$t('seleccionaTpv')">
                                    <el-option v-for="tpv in listTpv" class="select-primary" :value="tpv.id"
                                        :label="tpv.nameShow" :key="tpv.id">
                                    </el-option>
                                </el-select>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="respuesta && !tieneDimoni">

                <div class="col-md-12">
                    <div class="card">
                        <div class="row">

                            <div class="col-md-12">

                                <div class="row">

                                    <div class="col-md-12">

                                        <h5 class="tituloPedido">{{ $t('datosDelNegocio') }} {{ $t('enSage') }}</h5>
                                        <hr>
                                    </div>

                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="empresa"><strong>{{ $t('companya') }}</strong></label>
                                            <input v-model="negocio.empresa" id="empresa" class="form-control"
                                                type="text" />
                                        </div>

                                    </div>

                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="delegacion"><strong>{{ $t('delegacion') }}</strong></label>
                                            <input id="delegacion" v-model="negocio.delegacion" class="form-control"
                                                type="text" />
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="canal"><strong>{{ $t('canal') }} / {{ $t('proyecto') }}
                                                </strong></label>
                                            <input id="canal" v-model="negocio.canal" class="form-control" type="text" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <label class="col-md-3" style="padding-left: 0px; color: grey;">{{ $t('codigoEmpresaHelp')
                                }}</label>
                                <!--<label class="col-md-3" style="padding-left: 5px; color: grey;">Recuerda que el dato delegación se comparte entre todos los tpvs de un mismo negocio</label>-->
                            </div>
                            <div class="col-md-12 text-right">
                                <button @click="updateDatos()" class="btn btn-primary"><i class="fa fa-check-square"></i>
                                    {{ $t("guardar") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </template>
            <div class="col-md-12" v-if="respuesta">
                <div class="row">
                    <div class="col-md-12 text-right" >
                        <el-button @click="getResetDias()" type="success" v-if="!tieneDimoni">
                            <i class="fa-solid fa-arrows-rotate"></i> 
                            {{ $t('resetearDias') }}
                        </el-button>
                    
                        <el-button @click="getProdustsSinCuenta()" type="primary" v-if="tieneDimoni">
                            <i class="fa fa-file"></i>
                            {{ $t("exportarCAPTE") }}
                        </el-button>

                        <el-button @click="openModalSage200ExportacionFechas()" type="primary" v-if="respuesta && !tieneDimoni && !despachos">
                            <i class="fa fa-file"></i>
                            {{ $t("exportarSage200Fechas") }}
                        </el-button>
                    </div>
                </div>

                <b-tabs no-key-nav card nav-wrapper-class="tabsCustom" content-class="contentStyle">
                    <b-tab card title="Cuentas contables" title-link-class="tabCustom" active>
                        <b-card no-body class="pr-0 pl-0 pt-0">
                            <b-tabs card nav-wrapper-class="tabs2Custom">
                                <b-tab title="Cuentas de gastos y ventas" title-link-class="tabCustom" active>
                                    <div class="col-md-12" v-if="respuesta">
                                        <div>
                                            <br>
                                            <div class="row mb-2">
                                                <div class="col-md-12">
                                                    <button @click="openModal()" class="btn btn-primary ml-2"><i
                                                            class="fa fa-plus-square"></i>
                                                        {{ $t('nuevaCuenta') }}
                                                    </button>
                                                    <div class="float-right">
                                                        <!--<button @click="openModalIVA()" class="btn btn-primary"><i
                                                                        class="fa fa-user-tag"></i>
                                                                    Configurar cuentas IVA
                                                                </button>-->
                                                        <!--<button @click="openModalEspeciales()" class="btn btn-primary"><i
                                                                        class="fa fa-cogs"></i>
                                                                    Configurar cuentas especiales
                                                                </button>-->
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="table-responsive pl-2 pr-2"
                                                v-if="listSubCuentas.length > 0 && respuesta">
                                                <table class="table table-bordered table-striped">
                                                    <thead class="thead-dark">
                                                        <tr>
                                                            <th>{{ $t('nombre') }}</th>
                                                            <th>{{ $t('codigo') }}</th>
                                                            <!--<th width="15%">Proveedor</th>-->
                                                            <th width="20%">{{ $t('tipo') }}</th>
                                                            <th width="5%">{{ $t("acciones") }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="subCuenta in listSubCuentas" v-bind:key="subCuenta.id">
                                                            <td>
                                                                <div>{{ subCuenta.nombreCuenta }}</div>
                                                            </td>
                                                            <td>
                                                                <div>{{ subCuenta.codigoCuenta }}{{
                                                                    subCuenta.codigoSubCuenta }}
                                                                </div>
                                                            </td>
                                                            <!--<td>
                                                                    <div v-if="cuenta.nombreProveedor != ''">{{cuenta.nombreProveedor}}</div>
                                                                    <div v-else>Sin proveedor asignado</div>
                                                                </td>-->
                                                            <td>
                                                                <div v-if="subCuenta.tipo == 'B'">{{ $t('ventas') }}</div>
                                                                <div v-if="subCuenta.tipo == 'G'">{{ $t('gastos') }}</div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <a @click="showEditCuenta(subCuenta.id, subCuenta.nombreCuenta, subCuenta.codigoCuenta, subCuenta.codigoSubCuenta, subCuenta.tipo, subCuenta.idProveedor, subCuenta.idCuenta)"
                                                                        class="btn btn-danger btn-link btn-xs">
                                                                        <i v-tooltip.top-center="$i18n.t('editar')"
                                                                            class="fas fa-pencil-alt"
                                                                            style="color: orange"></i>
                                                                    </a>
                                                                    <!--<a @click="modalBorrarCuenta(cuenta.id)"
                                                                            class="btn btn-danger btn-link btn-xs">

                                                                            <i v-tooltip.top-center="'Eliminar'"
                                                                            class="fas fa-trash-alt text-danger"></i>

                                                                        </a>-->
                                                                </div>

                                                            </td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div v-else class="alert alert-danger ml-2 mr-2" role="alert">
                                                <span>{{ $t('noHayCuentasCreadasConElTpvSeleccionado') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </b-tab>
                                <b-tab title="Cuentas de proveedores y apuntes" title-link-class="tabCustom">
                                    <div class="col-md-12" v-if="respuesta">
                                        <div>
                                            <br>
                                            <div class="row mb-2">
                                                <div class="col-md-12">
                                                    <button @click="openModalProveedores()" class="btn btn-primary ml-2"><i
                                                            class="fa fa-plus-square"></i>
                                                        {{ $t('nuevaCuenta') }}
                                                    </button>
                                                    <div class="float-right">
                                                        <!--<button @click="openModalIVA()" class="btn btn-primary"><i
                                                                        class="fa fa-user-tag"></i>
                                                                    Configurar cuentas IVA
                                                                </button>-->
                                                        <!--<button @click="openModalEspeciales()" class="btn btn-primary"><i
                                                                        class="fa fa-cogs"></i>
                                                                    Configurar cuentas especiales
                                                                </button>-->
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="table-responsive pl-2 pr-2"
                                                v-if="listSubCuentasProveedores.length > 0 && respuesta">
                                                <table class="table table-bordered table-striped">
                                                    <thead class="thead-dark">
                                                        <tr>
                                                            <th>{{ $t('nombre') }}</th>
                                                            <th>{{ $t('codigo') }}</th>
                                                            <!--<th width="15%">Proveedor</th>-->
                                                            <th width="5%">{{ $t("acciones") }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="subCuenta in listSubCuentasProveedores"
                                                            v-bind:key="subCuenta.id">
                                                            <td>
                                                                <div>{{ subCuenta.nombreCuenta }}</div>
                                                            </td>
                                                            <td>
                                                                <div>{{ subCuenta.codigoCuenta }}{{
                                                                    subCuenta.codigoSubCuenta }}
                                                                </div>
                                                            </td>
                                                            <!--<td>
                                                                    <div v-if="cuenta.nombreProveedor != ''">{{cuenta.nombreProveedor}}</div>
                                                                    <div v-else>Sin proveedor asignado</div>
                                                                </td>-->
                                                            <td>
                                                                <div>
                                                                    <a @click="showEditCuenta(subCuenta.id, subCuenta.nombreCuenta, subCuenta.codigoCuenta, subCuenta.codigoSubCuenta, subCuenta.tipo, subCuenta.idProveedor, subCuenta.idCuenta)"
                                                                        class="btn btn-danger btn-link btn-xs">
                                                                        <i v-tooltip.top-center="$i18n.t('editar')"
                                                                            class="fas fa-pencil-alt"
                                                                            style="color: orange"></i>
                                                                    </a>
                                                                    <!--<a @click="modalBorrarCuenta(cuenta.id)"
                                                                            class="btn btn-danger btn-link btn-xs">

                                                                            <i v-tooltip.top-center="'Eliminar'"
                                                                            class="fas fa-trash-alt text-danger"></i>

                                                                        </a>-->
                                                                </div>

                                                            </td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div v-else class="alert alert-danger ml-2 mr-2" role="alert">
                                                <span>{{ $t('noHayCuentasCreadasConElTpvSeleccionado') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </b-tab>
                                <b-tab title="Cuentas de formas de pago" title-link-class="tabCustom">
                                    <div class="col-md-12" v-if="respuesta">
                                        <div>
                                            <br>
                                            <div class="row mb-2">
                                                <div class="col-md-12">
                                                    <button @click="openModalFormasPago()" class="btn btn-primary ml-2"><i
                                                            class="fa fa-plus-square"></i>
                                                        {{ $t('nuevaCuenta') }}
                                                    </button>
                                                    <div class="float-right">
                                                        <!--<button @click="openModalIVA()" class="btn btn-primary"><i
                                                                        class="fa fa-user-tag"></i>
                                                                    Configurar cuentas IVA
                                                                </button>-->
                                                        <!--<button @click="openModalEspeciales()" class="btn btn-primary"><i
                                                                        class="fa fa-cogs"></i>
                                                                    Configurar cuentas especiales
                                                                </button>-->
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="table-responsive pl-2 pr-2"
                                                v-if="listSubCuentasFormasPago.length > 0 && respuesta">
                                                <table class="table table-bordered table-striped">
                                                    <thead class="thead-dark">
                                                        <tr>
                                                            <th>{{ $t('nombre') }}</th>
                                                            <th>{{ $t('codigo') }}</th>
                                                            <!--<th width="15%">Proveedor</th>-->
                                                            <th width="5%">{{ $t("acciones") }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="subCuenta in listSubCuentasFormasPago"
                                                            v-bind:key="subCuenta.id">
                                                            <td>
                                                                <div>{{ subCuenta.nombreCuenta }}</div>
                                                            </td>
                                                            <td>
                                                                <div>{{ subCuenta.codigoCuenta }}{{
                                                                    subCuenta.codigoSubCuenta }}
                                                                </div>
                                                            </td>
                                                            <!--<td>
                                                                    <div v-if="cuenta.nombreProveedor != ''">{{cuenta.nombreProveedor}}</div>
                                                                    <div v-else>Sin proveedor asignado</div>
                                                                </td>-->
                                                            <td>
                                                                <div>
                                                                    <a @click="showEditCuenta(subCuenta.id, subCuenta.nombreCuenta, subCuenta.codigoCuenta, subCuenta.codigoSubCuenta, subCuenta.tipo, subCuenta.idProveedor, subCuenta.idCuenta)"
                                                                        class="btn btn-danger btn-link btn-xs">
                                                                        <i v-tooltip.top-center="$i18n.t('editar')"
                                                                            class="fas fa-pencil-alt"
                                                                            style="color: orange"></i>
                                                                    </a>
                                                                    <!--<a @click="modalBorrarCuenta(cuenta.id)"
                                                                            class="btn btn-danger btn-link btn-xs">

                                                                            <i v-tooltip.top-center="'Eliminar'"
                                                                            class="fas fa-trash-alt text-danger"></i>

                                                                        </a>-->
                                                                </div>

                                                            </td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div v-else class="alert alert-danger ml-2 mr-2" role="alert">
                                                <span>{{ $t('noHayCuentasCreadasConElTpvSeleccionado') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </b-tab>
                                <b-tab title="Cuentas únicas" title-link-class="tabCustom">
                                    <div class="col-md-12" v-if="respuesta">
                                        <div>
                                            <br>
                                            <div class="table-responsive pl-2 pr-2" v-if="respuesta">
                                                <span class="text-secondary"><small>Se utilizará esta cuenta para asociar
                                                        las agrupaciones de tickets/ventas.</small></span>
                                                <hr>
                                                <table class="table table-bordered table-striped">
                                                    <thead class="thead-dark">
                                                        <tr>
                                                            <th>{{ $t('nombre') }}</th>
                                                            <th>{{ $t('codigo') }}</th>
                                                            <!--<th width="15%">Proveedor</th>-->
                                                            <th width="5%">{{ $t("acciones") }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <span>{{ cuentaVA.nombre }}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaVA.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaVA)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <h4>Cuentas de IVA</h4>
                                                <span class="text-secondary"><small>Se utilizarán estas cuentas para
                                                        redirigir las cantidades de IVA devengado y soportado</small></span>
                                                <hr>
                                                <table class="table table-bordered table-striped">
                                                    <thead class="thead-dark">
                                                        <tr>
                                                            <th>{{ $t('nombre') }}</th>
                                                            <th>{{ $t('codigo') }}</th>
                                                            <!--<th width="15%">Proveedor</th>-->
                                                            <th width="5%">{{ $t("acciones") }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>

                                                                <span>{{cuentaIS0.nombre}}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaIS0.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1" @click="guardarCuentaEspecial(cuentaIS0)"><i class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>

                                                                <span>{{cuentaIS2.nombre}}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaIS2.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1" @click="guardarCuentaEspecial(cuentaIS2)"><i class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{cuentaIS4.nombre}}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaIS4.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaIS4)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{cuentaIS5.nombre}}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaIS5.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1" @click="guardarCuentaEspecial(cuentaIS5)"><i class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{cuentaIS75.nombre}}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaIS75.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1" @click="guardarCuentaEspecial(cuentaIS75)"><i class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{cuentaIS10.nombre}}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaIS10.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaIS10)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{ cuentaIS21.nombre }}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaIS21.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaIS21)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{cuentaID0.nombre}}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaID0.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1" @click="guardarCuentaEspecial(cuentaID0)"><i class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{cuentaID2.nombre}}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaID2.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1" @click="guardarCuentaEspecial(cuentaID2)"><i class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{cuentaID4.nombre}}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaID4.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaID4)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{cuentaID5.nombre}}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaID5.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1" @click="guardarCuentaEspecial(cuentaID5)"><i class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{cuentaID75.nombre}}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaID75.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1" @click="guardarCuentaEspecial(cuentaID75)"><i class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{cuentaID10.nombre}}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaID10.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaID10)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{ cuentaID21.nombre }}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaID21.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaID21)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{ cuentaBG.nombre }}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaBG.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaBG)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <h4>Cuentas Generales</h4>
                                                <span class="text-secondary"><small>Se utilizarán estas cuentas para
                                                        redirigir las ventas en caso de que no estén asociadas de forma
                                                        correcta las cuentas de proveedores, gastos, etc.</small></span>
                                                <hr>
                                                <table class="table table-bordered table-striped">
                                                    <thead class="thead-dark">
                                                        <tr>
                                                            <th>{{ $t('nombre') }}</th>
                                                            <th>{{ $t('codigo') }}</th>
                                                            <!--<th width="15%">Proveedor</th>-->
                                                            <th width="5%">{{ $t("acciones") }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <span>{{ cuentaPG.nombre }}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaPG.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaPG)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{ cuentaGG.nombre }}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaGG.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaGG)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{ cuentaCE.nombre }}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaCE.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaCE)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{ cuentaCC.nombre }}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaCC.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaCC)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{ cuentaCT.nombre }}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaCT.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaCT)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{ cuentaPR.nombre }}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaPR.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaPR)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{ cuentaGT.nombre }}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaGT.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaGT)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{ cuentaGD.nombre }}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaGD.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaGD)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span>{{ cuentaGE.nombre }}</span>
                                                            </td>
                                                            <td width="35%">
                                                                <el-input v-model="cuentaGE.codigo"></el-input>
                                                            </td>
                                                            <td class="text-center">
                                                                <button class="btn btn-success mt-1"
                                                                    @click="guardarCuentaEspecial(cuentaGE)"><i
                                                                        class="fa fa-save"></i></button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div v-else class="alert alert-danger ml-2 mr-2" role="alert">
                                                <span>{{ $t('noHayCuentasCreadasConElTpvSeleccionado') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </b-tab>
                    <b-tab title="Códigos de las cuentas" title-link-class="tabCustom">
                        <div class="col-md-12  pl-0 pr-0" v-if="respuesta">
                            <div class="card">
                                <span class="text-secondary"><small>{{
                                    $t('enEstaPantallaSeConfiguranLosCodigosDeLasCuentas') }}
                                        ({{ $t('formadosPor3Digitos') }});
                                        {{ $t('estosSonNecesariosParaConfigurarLasCuentasContables') }}.</small></span>
                                <span class="text-secondary"><small><span class="text-danger">*{{ $t('atencion') }}*</span>
                                        {{ $t('alEditarUnCodigoRelacionadoConUnaCuentaContableYaExistente') }},
                                        {{ $t('todoCambioQueSeProduzcaSobreEsteAfectaraTambienALaPropiaCuenta')
                                        }}.</small></span>
                                <hr>
                                <div class="row mb-2">
                                    <div class="col-md-12">
                                        <button @click="openModalSageAccount()" class="btn btn-primary"><i
                                                class="fa fa-plus-square"></i>
                                            {{ $t('nuevaCuenta') }}
                                        </button>
                                        <div class="float-right">
                                            <!--<button @click="openModalIVA()" class="btn btn-primary"><i
                                                            class="fa fa-user-tag"></i>
                                                        Configurar cuentas IVA
                                                    </button>-->
                                            <!--<button @click="openModalEspeciales()" class="btn btn-primary"><i
                                                            class="fa fa-cogs"></i>
                                                        Configurar cuentas especiales
                                                    </button>-->
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" v-if="listCuentasTable.length > 0 && respuesta">
                                    <table class="table table-bordered table-striped">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th width="65%">{{ $t('nombre') }}</th>
                                                <th width="10%" class="text-center">{{ $t('codigo') }}</th>
                                                <!--<th width="15%">Proveedor</th>-->
                                                <th width="20%" class="text-center">{{ $t('tipo') }}</th>
                                                <th width="5%" class="text-center">{{ $t("acciones") }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="cuenta in listCuentasTable" v-bind:key="cuenta.id">
                                                <td>
                                                    <div>{{ cuenta.name }}</div>
                                                </td>
                                                <td>
                                                    <div class="text-center">{{ cuenta.cuenta }}</div>
                                                </td>
                                                <td class="text-center">
                                                    <div v-if="cuenta.tipo == 'B'">{{ $t('ventas') }}</div>
                                                    <div v-if="cuenta.tipo == 'G'">{{ $t('gastos') }}</div>
                                                    <div v-if="cuenta.tipo == 'P'">{{ $t('proveedores') }}</div>
                                                    <div v-if="cuenta.tipo == 'C'">{{ $t('formaDePago') }}</div>
                                                    <div v-if="cuenta.tipo == 'A'">{{ $t('apuntes') }}</div>
                                                </td>
                                                <td>
                                                    <div>
                                                        <a @click="showEditSageAccount(cuenta.id, cuenta.name, cuenta.cuenta, cuenta.tipo)"
                                                            class="btn btn-danger btn-link btn-xs">
                                                            <i v-tooltip.top-center="$i18n.t('editar')"
                                                                class="fas fa-pencil-alt" style="color: orange"></i>
                                                        </a>
                                                    </div>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else class="alert alert-danger" role="alert">
                                    <span>{{ $t('noHayCuentasCreadasConElTpvSeleccionado') }}</span>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>

            </div>
            <!-- MODALES -->
            <modal name="modal-resetear-dias" ::adaptive=true :scrollable=true height="auto" width="400px"
                :clickToClose=false>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{ $t("resetearDias") }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-6">
                                <label>{{ $t('fechaIni') }}</label>
                                <datetime :value-zone="timezoneId" :auto="true" class="theme-numier" format="dd-MM-yyyy"
                                    :title="$t('fechaIni')" :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                                    input-class="form-control" v-model="fechaIniReseteo" placeholder="dd-MM-yyyy">
                                </datetime>
                            </div>
                            <div class="col-6">
                                <label>{{ $t('fechaFin') }}</label>
                                <datetime :value-zone="timezoneId" :auto="true" class="theme-numier" format="dd-MM-yyyy"
                                    :title="$t('fechaFin')" :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                                    input-class="form-control" v-model="fechaFinReseteo" placeholder="dd-MM-yyyy">
                                </datetime>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">

                            <button class="btn btn-danger" @click="closeModal()">
                                <i class="fa fa-window-close"></i>
                                {{ $t("cancelar") }}
                            </button>


                            <button @click="resetearDias()" class="btn btn-success">
                                <i class="fa-solid fa-arrows-rotate"></i>
                                {{ $t('resetearButton') }}
                            </button>
                        </div>
                    </div>
                </div>

            </modal>
            <modal name="modal-exportar-capte" ::adaptive=true :scrollable=true height="auto" width="400px"
                :clickToClose=false>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{ $t("exportarCAPTE") }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-4">
                                <label>{{ $t("fecha") }}</label>
                                <datetime :value-zone="timezoneId" :auto="true" class="theme-numier" format="dd-MM-yyyy"
                                    :title="$t('fecha')" :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                                    input-class="form-control" v-model="dateTo"></datetime>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">

                            <button class="btn btn-danger" @click="closeModal()">
                                <i class="fa fa-window-close"></i>
                                {{ $t("cancelar") }}
                            </button>


                            <a :href="urlExportCAPTE" class="btn btn-primary" :disabled="inProgress">
                                <i class="fa fa-file"></i>
                                {{ $t("exportar") }}
                            </a>
                        </div>
                    </div>
                </div>

            </modal>
            <modal name="modal-exportar-sage200fecha" ::adaptive=true :scrollable=true height="auto" width="600px"
                :clickToClose=false>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{ $t("exportarSage200Fechas") }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="col-md-12 row">
                            <div class="form-group" style="padding-right: 5%">
                                <label>{{ $t("fechaInicio") }}</label>

                                <datetime
                                    :value-zone="timezoneId"
                                    :auto="true"
                                    class="theme-numier"
                                    format="dd-MM-yyyy"
                                    :title="$t('fechaInicio')"
                                    :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                    input-class="form-control"
                                    v-model="dateFrom">
                                </datetime>
                            </div>

                            <div class="form-group">
                                <label>{{ $t("fechaFin") }}</label>

                                <datetime
                                    :value-zone="timezoneId"
                                    :auto="true"
                                    class="theme-numier"
                                    format="dd-MM-yyyy"
                                    :title="$t('fechaFin')"
                                    :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                    input-class="form-control"
                                    v-model="dateTo">
                                </datetime>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <el-checkbox
                                        v-model="exportarSoloGastos">
                                    <strong>{{$t("soloExportarGastos")}}</strong>
                                </el-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">

                            <button class="btn btn-danger" @click="closeModal()">
                                <i class="fa fa-window-close"></i>
                                {{ $t("cancelar") }}
                            </button>

                            <a :href="urlExportSage200Fecha" class="btn btn-primary" :disabled="inProgress">
                                <i class="fa fa-file"></i>
                                {{ $t("exportar") }}
                            </a>
                        </div>
                    </div>
                </div>

            </modal>
            <modal name="modal-crear-cuenta" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{ $t('crearNuevaCuenta') }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <!-- Muestro los tipos de venta y compra si ha abierto el modal en la pestaña de Ventas/Gastos -->
                            <div class="col-4" v-if="nuevaCuenta.tipo == 'B' || nuevaCuenta.tipo == 'G'">
                                <div class="form-group d-inline">
                                    <label>{{ $t('tipo') }}</label>
                                    <el-select class="select-default" v-model="nuevaCuenta.tipo">
                                        <el-option v-for="tipo in tiposCuenta" class="select-primary" :value="tipo.value"
                                            :label="tipo.label" :key="tipo.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <!-- Muestro el tipo proveedor si ha abierto el modal desde proveedores -->
                            <div class="col-4" v-if="nuevaCuenta.tipo == 'P' || nuevaCuenta.tipo == 'A'">
                                <div class="form-group d-inline">
                                    <label>{{ $t('tipo') }}</label>
                                    <el-select class="select-default" v-model="nuevaCuenta.tipo">
                                        <el-option v-for="tipo in tiposCuentaProveedor" class="select-primary"
                                            :value="tipo.value" :label="tipo.label" :key="tipo.value">
                                        </el-option>
                                    </el-select>
                                    <!-- INPUT ANTERIOR
                                    <el-input
                                        placeholder="Proveedor"
                                        :disabled="true">
                                    </el-input>-->
                                </div>
                            </div>

                            <!-- Muestro el tipo forma de pago si ha abierto el modal desde formas de pago -->
                            <div class="col-4" v-if="nuevaCuenta.tipo == 'C'">
                                <div class="form-group d-inline">
                                    <label>{{ $t('tipo') }}</label>
                                    <el-input placeholder="Forma de pago" :disabled="true">
                                    </el-input>
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="form-group">
                                    <label>{{ $t('nombre') }}</label>
                                    <el-input v-model="nuevaCuenta.nombre" type="text"></el-input>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- Muestro los códigos de 3 dígitos de ventas y compras -->
                            <div class="col-6" v-if="nuevaCuenta.tipo == 'B' || nuevaCuenta.tipo == 'G'">
                                <div class="form-group">
                                    <label>{{ $t('codigoDeLaCuenta') }}</label>
                                    <el-select class="select-default" v-model="nuevaCuenta.idCuenta">
                                        <el-option v-for="cuenta in listCuentas" class="select-primary" :value="cuenta.id"
                                            :label="'(' + cuenta.name + ') ' + cuenta.cuenta" :key="cuenta.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <!-- Muestro los códigos de 3 dígitos de proveedores si se ha abierto desde proveedores -->
                            <div class="col-6" v-if="nuevaCuenta.tipo == 'P' || nuevaCuenta.tipo == 'A'">
                                <div class="form-group">
                                    <label>{{ $t('codigoDeLaCuenta') }}</label>
                                    <el-select class="select-default" v-model="nuevaCuenta.idCuenta">
                                        <el-option v-for="cuenta in listCuentasProveedores" class="select-primary"
                                            :value="cuenta.id" :label="'(' + cuenta.name + ') ' + cuenta.cuenta"
                                            :key="cuenta.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <!-- Muestro los códigos de 3 dígitos de formas de pago si se ha abierto desde formas de pago -->
                            <div class="col-6" v-if="nuevaCuenta.tipo == 'C'">
                                <div class="form-group">
                                    <label>{{ $t('codigoDeLaCuenta') }}</label>
                                    <el-select class="select-default" v-model="nuevaCuenta.idCuenta">
                                        <el-option v-for="cuenta in listCuentasFormasPago" class="select-primary"
                                            :value="cuenta.id" :label="'(' + cuenta.name + ') ' + cuenta.cuenta"
                                            :key="cuenta.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label>{{ $t('codigoDeLaSubcuenta') }}</label>
                                    <el-input v-model="nuevaCuenta.codigoSubCuenta" type="text"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">

                            <button class="btn btn-danger" @click="closeModal()"><i class="fa fa-window-close"></i>
                                {{ $t("cancelar") }}
                            </button>

                            <button class="btn btn-primary" :disabled="inProgress" @click="crearNuevaCuenta()"><i
                                    class="fa fa-check-square"></i>
                                {{ $t("guardar") }}
                            </button>

                        </div>
                    </div>

                </div>
            </modal>
            <modal name="modal-crear-sageaccount" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{ $t('crearNuevoCodigoCuenta') }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">

                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{ $t('nombre') }}</label>
                                    <el-input v-model="newSageAccount.nombre" type="text"></el-input>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <div class="form-group">
                                    <label>{{ $t('tipo') }}</label>
                                    <el-select class="select-default" v-model="newSageAccount.tipo"
                                        placeholder="Seleccione un tipo">
                                        <el-option v-for="tipo in tiposSageAccount" class="select-primary"
                                            :value="tipo.value" :label="tipo.label" :key="tipo.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label>{{ $t('codigo') }}</label>
                                    <el-input v-model="newSageAccount.codigo" type="text"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">

                            <button class="btn btn-danger" @click="closeModal()"><i class="fa fa-window-close"></i>
                                {{ $t("cancelar") }}
                            </button>

                            <button class="btn btn-primary" :disabled="inProgress" @click="crearNuevaSageAccount()"><i
                                    class="fa fa-check-square"></i>
                                {{ $t("guardar") }}
                            </button>

                        </div>
                    </div>

                </div>
            </modal>
            <modal name="modal-editar-sageaccount" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{ $t('editarNuevoCodigoCuenta') }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">

                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{ $t('nombre') }}</label>
                                    <el-input v-model="sageAccountToEdit.nombre" type="text"></el-input>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <div class="form-group">
                                    <label>{{ $t('tipo') }}</label>
                                    <el-select disabled id="editTipoSageAccount" v-model="sageAccountToEdit.tipo"
                                        placeholder="Seleccione un tipo">
                                        <el-option v-for="tipo in tiposSageAccount" class="select-primary"
                                            :value="tipo.value" :label="tipo.label" :key="tipo.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label>{{ $t('codigo') }}</label>
                                    <el-input v-model="sageAccountToEdit.codigo" type="text"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">

                            <button class="btn btn-danger" @click="closeModal()"><i class="fa fa-window-close"></i>
                                {{ $t("cancelar") }}
                            </button>

                            <button class="btn btn-primary" :disabled="inProgress" @click="editarSageAccount()"><i
                                    class="fa fa-check-square"></i>
                                {{ $t("guardar") }}
                            </button>

                        </div>
                    </div>

                </div>
            </modal>
            <modal name="modal-cuentas-iva" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{ $t('configuracionCuentasIva') }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">

                        </div>
                        <div class="row">
                            <div class="col-2">
                                <div class="form-group">
                                    <label>{{ $t('iva') }}</label>
                                    <input type="text" class="form-control" disabled value="21">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label>{{ $t('codigoDeLaCuenta') }}</label>
                                    <el-input v-model="nuevaCuenta.codigo" type="text"></el-input>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label>{{ $t('codigoDeLaSubcuenta') }}</label>
                                    <el-select class="select-default" v-model="nuevaCuenta.idCuenta">
                                        <el-option v-for="cuenta in listCuentas" class="select-primary" :value="cuenta.id"
                                            :label="cuenta.cuenta + ' (' + cuenta.name + ') '" :key="cuenta.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">

                            <button class="btn btn-danger" @click="closeModal()"><i class="fa fa-window-close"></i>
                                {{ $t("cancelar") }}
                            </button>

                            <button class="btn btn-primary" :disabled="inProgress" @click="crearNuevaCuenta()"><i
                                    class="fa fa-check-square"></i>
                                {{ $t("guardar") }}
                            </button>

                        </div>
                    </div>

                </div>
            </modal>
            <modal name="modal-cuentas-especiales" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{ $t('configuracionCuentasEspeciales') }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">

                        </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <label>{{ $t('nombre') }}</label>
                                    <input type="text" class="form-control" disabled value="Gastos generales">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label>{{ $t('cuenta') }}</label>
                                    <el-input v-model="nuevaCuenta.codigo" type="text"></el-input>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label>{{ $t('subcuenta') }}</label>
                                    <el-select class="select-default" v-model="nuevaCuenta.idCuenta">
                                        <el-option v-for="cuenta in listCuentas" class="select-primary" :value="cuenta.id"
                                            :label="cuenta.cuenta + ' (' + cuenta.name + ') '" :key="cuenta.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">

                            <button class="btn btn-danger" @click="closeModal()"><i class="fa fa-window-close"></i>
                                {{ $t("cancelar") }}
                            </button>

                            <button class="btn btn-primary" :disabled="inProgress" @click="crearNuevaCuenta()"><i
                                    class="fa fa-check-square"></i>
                                {{ $t("guardar") }}
                            </button>

                        </div>
                    </div>

                </div>
            </modal>
            <modal name="modal-editar-cuenta" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{ $t('editarCuenta') }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <!-- Muestro los tipos para elegir si estamos editando una subcuenta venta o gastos -->
                            <div class="col-4" v-if="cuentaAEditar.tipo == 'B' || cuentaAEditar.tipo == 'G'">
                                <div class="form-group d-inline">
                                    <label>{{ $t('tipo') }}</label>
                                    <el-select class="select-default" v-model="cuentaAEditar.tipo">
                                        <el-option v-for="tipo in tiposCuenta" class="select-primary" :value="tipo.value"
                                            :label="tipo.label" :key="tipo.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="col-8" v-if="cuentaAEditar.tipo == 'B' || cuentaAEditar.tipo == 'G'">
                                <div class="form-group">
                                    <label>{{ $t('nombre') }}</label>
                                    <el-input v-model="cuentaAEditar.nombreCuenta" type="text"></el-input>
                                </div>
                            </div>
                            <div class="col-12" v-else>
                                <div class="form-group">
                                    <label>{{ $t('nombre') }}</label>
                                    <el-input v-model="cuentaAEditar.nombreCuenta" type="text"></el-input>
                                </div>
                            </div>
                        </div>
                        <div class="row">

                            <!-- Muestro las cuentas de gastos y ventas -->
                            <div class="col-6" v-if="cuentaAEditar.tipo == 'B' || cuentaAEditar.tipo == 'G'">
                                <div class="form-group">

                                    <label>{{ $t('codigoDeLaCuenta') }}</label>
                                    <el-select class="select-default" v-model="cuentaAEditar.idCuenta">
                                        <el-option v-for="cuenta in listCuentas" class="select-primary" :value="cuenta.id"
                                            :label="'(' + cuenta.name + ') ' + cuenta.cuenta" :key="cuenta.id">
                                        </el-option>
                                    </el-select>

                                </div>
                            </div>

                            <!-- Muestro las cuentas de proveedores -->
                            <div class="col-6" v-else-if="cuentaAEditar.tipo == 'P'">
                                <div class="form-group">

                                    <label>{{ $t('codigoDeLaCuenta') }}</label>
                                    <el-select class="select-default" v-model="cuentaAEditar.idCuenta">
                                        <el-option v-for="cuenta in listCuentasProveedores" class="select-primary"
                                            :value="cuenta.id" :label="'(' + cuenta.name + ') ' + cuenta.cuenta"
                                            :key="cuenta.id">
                                        </el-option>
                                    </el-select>

                                </div>
                            </div>

                            <!-- Muestro las cuentas de formas de pago -->
                            <div class="col-6" v-else-if="cuentaAEditar.tipo == 'C'">
                                <div class="form-group">

                                    <label>{{ $t('codigoDeLaCuenta') }}</label>
                                    <el-select class="select-default" v-model="cuentaAEditar.idCuenta">
                                        <el-option v-for="cuenta in listCuentasFormasPago" class="select-primary"
                                            :value="cuenta.id" :label="'(' + cuenta.name + ') ' + cuenta.cuenta"
                                            :key="cuenta.id">
                                        </el-option>
                                    </el-select>

                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label>{{ $t('codigoDeLaSubcuenta') }}</label>
                                    <el-input v-model="cuentaAEditar.codigoSubCuenta" type="text"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">

                            <button class="btn btn-danger" @click="closeModal()"><i class="fa fa-window-close"></i>
                                {{ $t("cancelar") }}
                            </button>

                            <button class="btn btn-primary" :disabled="inProgress" @click="editarCuenta()"><i
                                    class="fa fa-check-square"></i>
                                {{ $t("guardar") }}
                            </button>

                        </div>
                    </div>
                </div>
            </modal>
            <modal name="modal-producto-cuenta" ::adaptive=true :scrollable=true height="auto" :clickToClose=false>

                <div>
                    <div class="modal-header">
                        <h4 style="margin: 10px">¿Estás seguro de que quieres exportar el fichero CAPTE?</h4>
                    </div>
                    <div class="modal-body">
                        <h5>{{ $t("productos") }} sin cuenta asociada</h5>
                        <div class="row table-wrapper-scroll-y my-custom-scrollbar" style="margin: 10px">
                            <table class="table table-bordered table-striped ">
                                <thead class="thead-dark ">
                                    <tr>
                                        <th>{{ $t('nombre') }}</th>
                                        <th>{{ $t('categoria') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="producto in productos">
                                        <td>{{ producto.name }}</td>
                                        <td>{{ producto.category }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">

                            <button class="btn btn-danger" @click="closeModal()">
                                <i class="fa fa-window-close"></i>
                                {{ $t("cancelar") }}
                            </button>

                            <button class="btn btn-primary" @click="openModalSageExportacion();">
                                <i class="fa-sharp fa-solid fa-check"></i>
                                {{ $t("exportar") }}
                            </button>
                        </div>
                    </div>
                </div>

            </modal>
        </div>

    </div>
</template>

<script>

import { DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Checkbox, CheckboxGroup } from 'element-ui'
import Datetime from "vue-datetime";
import { Loading } from 'element-ui';
import swal from 'sweetalert2'
import moment from 'moment'
import { BTabs, CardPlugin } from 'bootstrap-vue';
import Table from '../../../../components/Table.vue';

export default {
    name: "ImportacionSage",
    created() {
        this.loadingGeneral = Loading.service({ text: this.$t('cargando') });
        this.$store.dispatch('setNameRoute', this.$t('configuracionSAGE'));
        this.getBusiness();
        //this.getConfigDimoni();
    },

    components: {
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Option.name]: Option,
        [BTabs.name]: BTabs,
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
        [CardPlugin.name]: CardPlugin,
        [Datetime.name]: Datetime
    },

    data() {
        return {
            fechaIniReseteo: new Date().toISOString(),
            fechaFinReseteo: new Date().toISOString(),
            dateTo: new Date().toISOString(),
            dateFrom: new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                1
            ).toISOString(),
            exportarSoloGastos: false,
            loading: false,
            loadingGeneral: null,
            cuentaAEditar: {
                id: '',
                idProveedor: '0',
                codigoCuenta: '',
                codigoSubCuenta: '',
                nombreCuenta: '',
                idCuenta: '',
                tipo: ''
            },
            nuevaCuenta: {
                nombre: '',
                idProveedor: '0',
                codigo: '',
                codigoSubCuenta: '',
                idCuenta: '',
                tipo: 'B',
            },

            newSageAccount: {
                nombre: '',
                codigo: '',
                tipo: ''
            },

            sageAccountToEdit: {
                id: '',
                nombre: '',
                codigo: '',
                tipo: ''
            },

            listProveedores: [],

            //Cuentas que no se pueden crear
            listCuentas: [],
            listCuentasProveedores: [],
            listCuentasFormasPago: [],
            listCuentasTable: [],

            //Subcuentas con el código completo (incluyendo cuenta)
            listSubCuentasProveedores: [],
            listSubCuentasFormasPago: [],
            listSubCuentas: [],
            listSubCuentasIVA: [],

            listBusinesses: [],
            listCheckBoxTpv: [],
            idBusiness: 0,
            respuesta: false,
            despachos: false,
            listTpv: [],
            idsTPV: [],
            idTpv: 0,
            idCompany: 0,
            inProgress: false,
            negocio: {
                empresa: '',
                delegacion: '',
                canal: '',
            },

            tiposCuenta: [{
                value: 'B',
                label: this.$t('ventas')
            }, {
                value: 'G',
                label: this.$t('gastos')
            }],

            tiposCuentaProveedor: [{
                value: 'P',
                label: this.$t('proveedor')
            }, {
                value: 'A',
                label: this.$t('apunte')
            }],

            tiposSageAccount: [{
                value: 'B',
                label: this.$t('ventas')
            }, {
                value: 'G',
                label: this.$t('gastos')
            }, {
                value: 'P',
                label: this.$t('proveedores')
            }, {
                value: 'C',
                label: this.$t('formaDePago')
            }, {
                value: 'A',
                label: this.$t('apuntes')
            }],
            cuentaIS0: {
                id: 0,
                nombre: "IVA SOPORTADO 0%",
                tipo: "IS",
                codigo: "",
            },
            cuentaIS2: {
                id: 0,
                nombre: "IVA SOPORTADO 2%",
                tipo: "IS",
                codigo: "",
            },
            cuentaIS4: {
                id: 0,
                nombre: "IVA SOPORTADO 4%",
                tipo: "IS",
                codigo: "",
            },
            cuentaIS5: {
                id: 0,
                nombre: "IVA SOPORTADO 5%",
                tipo: "IS",
                codigo: "",
            },
            cuentaIS75: {
                id: 0,
                nombre: "IVA SOPORTADO 7.5%",
                tipo: "IS",
                codigo: "",
            },
            cuentaIS10: {
                id: 0,
                nombre: "IVA SOPORTADO 10%",
                tipo: "IS",
                codigo: "",
            },
            cuentaIS21: {
                id: 0,
                nombre: "IVA SOPORTADO 21%",
                tipo: "IS",
                codigo: "",
            },
            cuentaID0: {
                id: 0,
                nombre: "IVA DEVENGADO 0%",
                tipo: "ID",
                codigo: "",
            },
            cuentaID2: {
                id: 0,
                nombre: "IVA DEVENGADO 2%",
                tipo: "ID",
                codigo: "",
            },
            cuentaID4: {
                id: 0,
                nombre: "IVA DEVENGADO 4%",
                tipo: "ID",
                codigo: "",
            },
            cuentaID5: {
                id: 0,
                nombre: "IVA DEVENGADO 5%",
                tipo: "ID",
                codigo: "",
            },
            cuentaID75: {
                id: 0,
                nombre: "IVA DEVENGADO 7.5%",
                tipo: "ID",
                codigo: "",
            },
            cuentaID10: {
                id: 0,
                nombre: "IVA DEVENGADO 10%",
                tipo: "ID",
                codigo: "",
            },
            cuentaID21: {
                id: 0,
                nombre: "IVA DEVENGADO 21%",
                tipo: "ID",
                codigo: "",
            },
            cuentaBG: {
                id: 0,
                nombre: "BASE IMPONIBLE",
                tipo: "BG",
                codigo: "",
            },
            cuentaVA: {
                id: 0,
                nombre: "VENTAS AGRUPADAS",
                tipo: "VA",
                codigo: "",
            },
            cuentaPG: {
                id: 0,
                nombre: "PROVEEDORES GENERAL",
                tipo: "PG",
                codigo: ""
            },
            cuentaGG: {
                id: 0,
                nombre: "GASTOS GENERAL",
                tipo: "GG",
                codigo: ""
            },
            cuentaCE: {
                id: 0,
                nombre: "COBRO EFECTIVO",
                tipo: "CE",
                codigo: "",
            },
            cuentaCC: {
                id: 0,
                nombre: "COBRO CHEQUE",
                tipo: "CC",
                codigo: "",
            },
            cuentaCT: {
                id: 0,
                nombre: "COBRO TARJETA",
                tipo: "CT",
                codigo: "",
            },
            cuentaPR: {
                id: 0,
                nombre: "PROPINAS",
                tipo: "PR",
                codigo: "",
            },
            cuentaGT: {
                id: 0,
                nombre: "COBRO GASTO TRANSFERENCIA",
                tipo: "GT",
                codigo: "",
            },
            cuentaGD: {
                id: 0,
                nombre: "COBRO GASTO DOMICILIACION",
                tipo: "GD",
                codigo: "",
            },
            cuentaGE: {
                id: 0,
                nombre: "COBRO GASTO EFECTIVO",
                tipo: "GE",
                codigo: "",
            },

            tieneDimoni: false,
            productos: [],
            sinCuenta: false,
        }
    },
    computed: {
        timezoneId() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        },
        urlExportCAPTE() {
            return this.$store.getters.apiUrl + "/exportacionDimoni/exportacionDimoni?idTpv=" + this.idTpv + "&datefrom=" + moment(this.dateTo).startOf("day").unix() + "&dateto=" + moment(this.dateTo).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
        },
        urlExportSage200Fecha() {
            return this.$store.getters.apiUrl + "/exportacionSage/exportarSAGEAsientosContablesAutomaticoPorFechas?idTpv=" + this.idTpv + "&datefrom=" + moment(this.dateFrom).startOf("day").unix() + "&dateto=" + moment(this.dateTo).endOf("day").unix() + "&sologastos=" + this.exportarSoloGastos + "&jwt=" + this.$store.getters.jwt
        }
    },
    methods: {
        getResetDias() {
            let vm = this;
            this.openModalResetearDias();
        },
        resetearDias() {
            this.loading = Loading.service({ text: "Cargando..." });

            let config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let fechaFin = new Date(this.fechaFinReseteo);
            fechaFin.setHours(23, 59, 59, 999);
            fechaFin.setUTCHours(23, 59, 59, 999);

            let params = {
                idTpv: this.idTpv,
                fechaIni: (new Date(this.fechaIniReseteo)).getTime() / 1000,
                fechaFin: fechaFin.getTime() / 1000
            }

            let vm = this;
            this.axios
                .post(this.$store.getters.apiUrl + "/exportacionSage/resetearDias", params, config)
                .then(function (response) {

                    vm.loading.close();

                    if (response.data.response) {

                        vm.loading = 
                        vm.$notify({
                            message: vm.$t('reseteoExitoso'),
                            icon: 'nc-icon nc-check-2',
                            timeout: 2000,
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'success'
                        });

                        vm.$modal.hide("modal-resetear-dias");

                    } else {
                        swal({
                            title: vm.$t('reseteoError'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                }).catch(function (error) {
                    console.log(error);
                });
        },
        getProdustsSinCuenta() {
            var config = {
                params: {
                    idTpv: this.idTpv,
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios
                .get(
                    this.$store.getters.apiUrl + "/exportacionDimoni/productoSinCuenta",
                    config
                ).then(function (response) {
                    // console.log(response.data.result.length);
                    if (response.data.result.length != 0) {
                        vm.productos = response.data.result;
                        vm.openModalProductssinCuenta();

                    } else {
                        vm.openModalSageExportacion();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getConfigDimoni() {
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    idTpv: this.idTpv,
                    numConfig: 83,
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios
                .get(
                    this.$store.getters.apiUrl + "general/getConfigTpv",
                    config
                ).then(function (response) {
                    if (response.data.result) {
                        vm.tieneDimoni = true;
                        vm.respuesta = true;
                    } else {
                        vm.tieneDimoni = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        tieneSageDespachos() {
            if (this.idBusiness.length > 0) {
                var config = {
                    params: {
                        idTpv: this.idTpv,
                        numConfig: '73',
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                    .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                    .then(function (response) {
                        if (response.data.response == true) {
                            vm.despachos = true;
                            vm.getSageBusinessData();
                            vm.getCuentasParaMostrar();
                            vm.getCuentasEspeciales();
                        } else {
                            vm.despachos = false;
                            swal({
                                title: vm.$t("loSientoSuNegocioNoTieneContratadoSAGE"),
                                text: vm.$t("paraMasInformacionContacteConComerciales"),
                                confirmButtonClass: "btn btn-info btn-fill",
                                type: "error",
                            });
                            vm.listSage = [];
                        }
                        vm.loading = false;
                        vm.loadingGeneral.close();
                    }).catch(function (error) {
                        console.log(error);
                    });
            }
        },
        tieneAcceso() {
            if (this.idBusiness.length > 0) {
                var config = {
                    params: {
                        idTpv: this.idTpv,
                        jwt: this.$store.getters.jwt,
                    },

                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                    .get(this.$store.getters.apiUrl + "importacion/getConfigContable", config)
                    .then(function (response) {
                        if (response.data.response == true) {

                            if (response.data.result.config == "73") {
                                vm.despachos = true;
                            } else if (response.data.result.nombre == "36") {
                                vm.respuesta = true;
                            }

                            vm.getSageBusinessData();
                            vm.getCuentasParaMostrar();
                            vm.getCuentasEspeciales();

                        } else {
                            vm.respuesta = false;
                            vm.despachos = false;
                            swal({
                                title: vm.$t("loSientoSuNegocioNoTieneContratadoSAGE"),
                                text: vm.$t("paraMasInformacionContacteConComerciales"),
                                confirmButtonClass: "btn btn-info btn-fill",
                                type: "error",
                            });
                            vm.listSage = [];
                        }
                        vm.loading = false;
                        vm.loadingGeneral.close();
                    }).catch(function (error) {
                        console.log(error);
                    });
            }
        },
        tieneSage() {
            if (this.idBusiness.length > 0) {
                var config = {
                    params: {
                        idTpv: this.idTpv,
                        numConfig: '36',
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                    .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                    .then(function (response) {
                        if (response.data.response == true) {
                            vm.respuesta = true;
                            vm.getSageBusinessData();
                            vm.getCuentasParaMostrar();
                            vm.getCuentasEspeciales();
                        } else {
                            vm.respuesta = false;
                            vm.tieneSageDespachos();
                            /*swal({
                                title: vm.$t("loSientoSuNegocioNoTieneContratadoSAGE"),
                                text: vm.$t("paraMasInformacionContacteConComerciales"),
                                confirmButtonClass: "btn btn-info btn-fill",
                                type: "error",
                            });*/
                            vm.listSage = [];
                        }
                        vm.loading = false;
                        vm.loadingGeneral.close();
                    }).catch(function (error) {
                        console.log(error);
                    });
            }
        },

        //Cada vez que se elige un negocio distinto, hay que setear el negocio actual y las id actuales, así como llamar a los tpvs del mismo

        cambiarNegocio() {
            this.loadingGeneral = Loading.service({ text: this.$t('cargando') });
            this.listBusinesses.forEach((business) => {
                if (business.id == this.idBusiness) {
                    this.$store.dispatch("setIdBusiness", this.idBusiness);
                    this.negocio.empresa = business.codigoEmpresa;
                    this.negocio.delegacion = business.codigoDelegacion;
                    this.negocio.canal = business.codigoCanal;
                    this.idTpv = business.idTpv;
                    this.idCompany = business.idCompany
                    this.getTpv();

                }
            });
        },

        //Cambia de tpv por id

        cambiarTpv() {

            this.getTpvById();
        },

        //Carga inicial de todos los negocios con los datos cargados del primero

        getBusiness() {

            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "importacion/getBusinessesByUserForSage", config)
                .then(function (response) {

                    if (response.data.response) {

                        let business = response.data.result[0];
                        if (vm.$store.getters.idBusiness) {
                            let xbus = response.data.result.find((negocio) => (negocio.id == vm.$store.getters.idBusiness));

                            if (xbus != null && xbus != undefined) {
                                business = xbus;
                            }
                        }
                        vm.idBusiness = business.id;
                        vm.idCompany = business.idCompany;
                        vm.negocio.delegacion = business.codigoDelegacion;
                        vm.negocio.empresa = business.codigoEmpresa;

                        vm.listBusinesses = response.data.result;
                        vm.idTpv = business.idTpv;

                        vm.getTpvById();
                        vm.getTpv();
                    } else {
                        vm.loadingGeneral.close();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        //Cargo todos los tpvs del idBusiness
        getTpv() {
            this.listTpv = [];
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                .then(function (response) {
                    if (response.data.response) {
                        for (let i = 0; i < response.data.result.length; i++) {
                            vm.idsTPV.push(response.data.result[i].id)
                        }

                        vm.listCheckBoxTpv = response.data.result;
                        let printer = {
                            nameShow: vm.$t('todos'),
                            id: 0
                        };

                        for (let i = 0; i < response.data.result.length; i++) {
                            let printername = {
                                nameShow: response.data.result[i].nameShow,
                                id: response.data.result[i].id
                            };

                            vm.listTpv.push(printername)
                        }
                        vm.tieneAcceso();
                        vm.getConfigDimoni();
                    }
                    vm.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        //Cargo un tpv por id
        getTpvById() {
            var config = {
                params: {
                    idTpv: this.idTpv,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "importacion/getTpvByIdForSage", config)
                .then(function (response) {

                    if (response.data.response) {

                        vm.negocio.canal = response.data.result[0].codigoCanal;

                        vm.tieneAcceso();
                    }


                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        //Me traigo las cuentas del tpv seleccionado de venta y gasto

        getSageBusinessData() {
            var config = {
                params: {
                    idTpv: this.idTpv,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "importacion/getSageBusinessDataByIdTpv", config)
                .then(function (response) {

                    if (response.data.response) {

                        vm.listSubCuentas = response.data.result;

                        vm.respuesta = true;

                        vm.loadingGeneral.close();
                        vm.getSubCuentasProveedores();
                        vm.getSubCuentasFormasPago();
                    }
                    vm.loading = false;


                })
                .catch(function (error) {
                    console.log(error);
                });

        },

        //Me traigo las subcuentas cada vez que se abre el modal de crear una cuenta o el de editar una

        getCuentas() {
            this.listCuentas = [];
            this.listCuentasProveedores = [];
            this.listCuentasFormasPago = [];
            var config = {
                params: {
                    idTpv: this.idTpv,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "importacion/getCuentasByIdTpv", config)
                .then(function (response) {

                    if (response.data.response) {

                        response.data.result.forEach(cuenta => {

                            if (cuenta.tipo == "B" || cuenta.tipo == "G") {
                                //Añado a la lista de cuentas de tipo venta/gasto
                                vm.listCuentas.push(cuenta);

                            }

                            if (cuenta.tipo == "P") {
                                //Añado a la lista de cuentas de tipo proveedores
                                vm.listCuentasProveedores.push(cuenta);

                            }

                            if (cuenta.tipo == "A") {
                                //Añado a la lista de cuentas de tipo proveedores
                                vm.listCuentasProveedores.push(cuenta);

                            }

                            if (cuenta.tipo == "C") {
                                //Añado a la lista de cuentas de tipo formas de pago
                                vm.listCuentasFormasPago.push(cuenta);

                            }
                        })

                        vm.respuesta = true;

                    }
                    vm.loading = false;


                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        //Lo utilizo para traerme las cuentas en el panel de códigos de las cuentas
        getCuentasParaMostrar() {
            this.listCuentas = [];
            this.listCuentasProveedores = [];
            this.listCuentasFormasPago = [];
            this.listCuentasTable = [];

            var config = {
                params: {
                    idTpv: this.idTpv,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "importacion/getCuentasByIdTpv", config)
                .then(function (response) {

                    if (response.data.response) {
                        //Base (Ventas), Gastos (Compras), Proveedores, Cobros (Formas de pago)
                        let arrayTipos = ["B", "G", "P", "C", "A"];

                        vm.listCuentasTable = [];

                        response.data.result.forEach(cuenta => {

                              if (arrayTipos.includes(cuenta.tipo)) {
                                  //Añado a la lista de cuentas 
                                  vm.listCuentasTable.push(cuenta);
                              }
                              
                        })

                        vm.respuesta = true;

                    }
                    vm.loading = false;


                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        guardarCuentaEspecial(cuenta) {
            //Se pasa N al check campos si se está creando una cuenta nueva
            // console.log(cuenta)
            if (cuenta.codigo != "" && cuenta.codigo.length >= 6) {

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };

                var params = {
                    idTpv: this.idTpv,
                    cuenta: cuenta,
                }

                let vm = this;
                this.axios.post(this.$store.getters.apiUrl + "importacion/saveCuentaEspecial", params, config)
                    .then(function (response) {
                        vm.inProgress = false;
                        if (response.data.response) {
                            vm.$notify({
                                message: "Cuenta actualizada correctamente",
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                            vm.getSageBusinessData();
                            vm.getCuentasParaMostrar();
                            vm.getCuentasEspeciales();

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
            } else {
                swal({
                    title: this.$t('atencion'),
                    text: "El código no puede estar vacío ni su longitud puede ser inferior a 6",
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
            }
        },
        getCuentasEspeciales() {
            var config = {
                params: {
                    idTpv: this.idTpv,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "importacion/getCuentasEspecialesByIdTpv", config)
                .then(function (response) {

                    if (response.data.response) {

                        response.data.result.forEach(result => {

                            switch (result.tipo) {
                            
                                case "IS0":
                                    vm.cuentaIS0.codigo = result.codigo;
                                    vm.cuentaIS0.id = result.id;
                                    vm.cuentaIS0.nombre = result.nombre;
                                    break;
                                case "IS2":
                                    vm.cuentaIS2.codigo = result.codigo;
                                    vm.cuentaIS2.id = result.id;
                                    vm.cuentaIS2.nombre = result.nombre;
                                    break;
                                    
                                case "IS4":
                                    vm.cuentaIS4.codigo = result.codigo;
                                    vm.cuentaIS4.id = result.id;
                                    vm.cuentaIS4.nombre = result.nombre;
                                    break;
                                    
                                case "IS5":
                                    vm.cuentaIS5.codigo = result.codigo;
                                    vm.cuentaIS5.id = result.id;
                                    vm.cuentaIS5.nombre = result.nombre;
                                    break;
                                case "IS75":
                                    vm.cuentaIS75.codigo = result.codigo;
                                    vm.cuentaIS75.id = result.id;
                                    vm.cuentaIS75.nombre = result.nombre;
                                    break;
                                    
                                case "IS10":
                                    vm.cuentaIS10.codigo = result.codigo;
                                    vm.cuentaIS10.id = result.id;
                                    vm.cuentaIS10.nombre = result.nombre;
                                    break;

                                case "IS21":
                                    vm.cuentaIS21.codigo = result.codigo;
                                    vm.cuentaIS21.id = result.id;
                                    vm.cuentaIS21.nombre = result.nombre;
                                    break;

                                case "ID0":
                                    vm.cuentaID0.codigo = result.codigo;
                                    vm.cuentaID0.id = result.id;
                                    vm.cuentaID0.nombre = result.nombre;
                                    break;
                                case "ID2":
                                    vm.cuentaID2.codigo = result.codigo;
                                    vm.cuentaID2.id = result.id;
                                    vm.cuentaID2.nombre = result.nombre;
                                    break;

                                case "ID4":
                                    vm.cuentaID4.codigo = result.codigo;
                                    vm.cuentaID4.id = result.id;
                                    vm.cuentaID4.nombre = result.nombre;
                                    break;

                                case "ID5":
                                    vm.cuentaID5.codigo = result.codigo;
                                    vm.cuentaID5.id = result.id;
                                    vm.cuentaID5.nombre = result.nombre;
                                    break;
                                case "ID75":
                                    vm.cuentaID75.codigo = result.codigo;
                                    vm.cuentaID75.id = result.id;
                                    vm.cuentaID75.nombre = result.nombre;
                                    break;

                                case "ID10":
                                    vm.cuentaID10.codigo = result.codigo;
                                    vm.cuentaID10.id = result.id;
                                    vm.cuentaID10.nombre = result.nombre;
                                    break;

                                case "ID21":
                                    vm.cuentaID21.codigo = result.codigo;
                                    vm.cuentaID21.id = result.id;
                                    vm.cuentaID21.nombre = result.nombre;
                                    break;

                                case "BG":
                                    vm.cuentaBG.codigo = result.codigo;
                                    vm.cuentaBG.id = result.id;
                                    vm.cuentaBG.nombre = result.nombre;
                                    break;

                                case "VA":
                                    vm.cuentaVA.codigo = result.codigo;
                                    vm.cuentaVA.id = result.id;
                                    vm.cuentaVA.nombre = result.nombre;
                                    break;

                                case "PG":
                                    vm.cuentaPG.codigo = result.codigo;
                                    vm.cuentaPG.id = result.id;
                                    vm.cuentaPG.nombre = result.nombre;
                                    break;

                                case "GG":
                                    vm.cuentaGG.codigo = result.codigo;
                                    vm.cuentaGG.id = result.id;
                                    vm.cuentaGG.nombre = result.nombre;
                                    break;

                                case "CE":
                                    vm.cuentaCE.codigo = result.codigo;
                                    vm.cuentaCE.id = result.id;
                                    vm.cuentaCE.nombre = result.nombre;
                                    break;

                                case "CC":
                                    vm.cuentaCC.codigo = result.codigo;
                                    vm.cuentaCC.id = result.id;
                                    vm.cuentaCC.nombre = result.nombre;
                                    break;

                                case "CT":
                                    vm.cuentaCT.codigo = result.codigo;
                                    vm.cuentaCT.id = result.id;
                                    vm.cuentaCT.nombre = result.nombre;
                                    break;

                                case "PR":
                                    vm.cuentaPR.codigo = result.codigo;
                                    vm.cuentaPR.id = result.id;
                                    vm.cuentaPR.nombre = result.nombre;
                                    break;

                                case "GT":
                                    vm.cuentaGT.codigo = result.codigo;
                                    vm.cuentaGT.id = result.id;
                                    vm.cuentaGT.nombre = result.nombre;
                                    break;

                                case "GD":
                                    vm.cuentaGD.codigo = result.codigo;
                                    vm.cuentaGD.id = result.id;
                                    vm.cuentaGD.nombre = result.nombre;
                                    break;

                                case "GE":
                                    vm.cuentaGE.codigo = result.codigo;
                                    vm.cuentaGE.id = result.id;
                                    vm.cuentaGE.nombre = result.nombre;
                                    break;
                            }
                        });

                        vm.respuesta = true;

                    }
                    vm.loading = false;


                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        //Consigo las cuentas de proveedores

        getSubCuentasProveedores() {
            this.listSubCuentasProveedores = [];
            var config = {
                params: {
                    idTpv: this.idTpv,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "importacion/getSubCuentasProveedores", config)
                .then(function (response) {

                    if (response.data.response) {

                        vm.listSubCuentasProveedores = response.data.result;
                        //vm.listCuentas = response.data.result;
                        vm.respuesta = true;

                    }
                    vm.loading = false;


                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        //Consigo las cuentas de formas de pago

        getSubCuentasFormasPago() {
            this.listSubCuentasFormasPago = [];
            var config = {
                params: {
                    idTpv: this.idTpv,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "importacion/getSubCuentasFormasPago", config)
                .then(function (response) {

                    if (response.data.response) {

                        vm.listSubCuentasFormasPago = response.data.result;
                        //vm.listCuentas = response.data.result;
                        vm.respuesta = true;

                    }
                    vm.loading = false;


                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        //Comprueba los campos para ver si están vacíos o no cumplen una serie de requisitos

        checkCampos(parametro) {

            //N de nuevo

            if (parametro == 'N') {
                if (this.nuevaCuenta.codigoSubCuenta == '' || this.nuevaCuenta.nombre == '' || this.nuevaCuenta.idCuenta == '') {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('losCamposNombreCodigoDeCuentaYCodigoDeSubcuentaDebenEstarRellenos'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else {

                    if (this.nuevaCuenta.codigoSubCuenta.length > 12) {
                        swal({
                            title: this.$t('atencion'),
                            text: this.$t('laLongitudMaximaDeLasSubCuentas'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                        return false;
                    } else if (isNaN(parseInt(this.nuevaCuenta.codigoSubCuenta))) {
                        swal({
                            title: this.$t('atencion'),
                            text: "No puede introducir caracteres que no sean números",
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        return false;
                    } else {
                        return true;
                    }
                }
                //E de edición
            } else if (parametro == 'E') {
                if (this.cuentaAEditar.codigoSubCuenta == '' || this.cuentaAEditar.idCuenta == '' || this.cuentaAEditar.nombreCuenta == '') {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('losCamposNombreCodigoDeCuentaYCodigoDeSubcuentaDebenEstarRellenos'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else {
                    if (this.cuentaAEditar.codigoSubCuenta.length > 12) {
                        swal({
                            title: this.$t('atencion'),
                            text: this.$t('laLongitudMaximaDeLasSubCuentas'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                        return false;
                    } else if (isNaN(parseInt(this.cuentaAEditar.codigoSubCuenta))) {
                        swal({
                            title: this.$t('atencion'),
                            text: "No puede introducir caracteres que no sean números",
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        return false;
                    } else {
                        return true;
                    }
                }

                //NSA de New Sage Account
            } else if (parametro == 'NSA') {
                if (this.newSageAccount.codigo == '' || this.newSageAccount.nombre == '' || this.newSageAccount.tipo == '') {
                    swal({
                        title: this.$t('atencion'),
                        text: 'Los campos nombre, tipo y código deben estar rellenos',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else {
                    if (this.newSageAccount.codigo.length > 3) {
                        swal({
                            title: this.$t('atencion'),
                            text: 'La longitud máxima de las cuentas es de tres caracteres',
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                        return false;
                    } else if (isNaN(parseInt(this.newSageAccount.codigo))) {
                        swal({
                            title: this.$t('atencion'),
                            text: "No puede introducir caracteres que no sean números",
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        return false;
                    } else {
                        return true;
                    }
                }
            } else if (parametro == 'ESA') {
                if (this.sageAccountToEdit.codigo == '' || this.sageAccountToEdit.nombre == '' || this.sageAccountToEdit.tipo == '') {
                    swal({
                        title: this.$t('atencion'),
                        text: 'Los campos nombre, tipo y código deben estar rellenos',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else {
                    if (this.sageAccountToEdit.codigo.length > 3) {
                        swal({
                            title: this.$t('atencion'),
                            text: 'La longitud máxima de las cuentas es de tres caracteres',
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                        return false;
                    } else if (isNaN(parseInt(this.sageAccountToEdit.codigo))) {
                        swal({
                            title: this.$t('atencion'),
                            text: "No puede introducir caracteres que no sean números",
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        return false;
                    } else {
                        return true;
                    }
                }
            }

            return false;

        },
        //Crea una nueva cuenta
        crearNuevaCuenta() {

            //Se pasa N al check campos si se está creando una cuenta nueva
            if (this.checkCampos('N')) {

                this.listCuentas.forEach(cuenta => {
                    if (cuenta.id == this.nuevaCuenta.idCuenta) {
                        this.nuevaCuenta.codigo = cuenta.cuenta;
                    }
                })

                this.listCuentasProveedores.forEach(cuenta => {
                    if (cuenta.id == this.nuevaCuenta.idCuenta) {
                        this.nuevaCuenta.codigo = cuenta.cuenta;
                    }
                })

                this.listCuentasFormasPago.forEach(cuenta => {
                    if (cuenta.id == this.nuevaCuenta.idCuenta) {
                        this.nuevaCuenta.codigo = cuenta.cuenta;
                    }
                })

                this.inProgress = true;
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };

                var params = {
                    idTpv: this.idTpv,
                    codigoCuenta: this.nuevaCuenta.codigo,
                    nombreCuenta: this.nuevaCuenta.nombre,
                    codigoSubCuenta: this.nuevaCuenta.codigoSubCuenta,
                    idCuenta: this.nuevaCuenta.idCuenta,
                    tipo: this.nuevaCuenta.tipo,
                }
                let vm = this;
                this.axios.post(this.$store.getters.apiUrl + "importacion/newCuentaByIdTpv", params, config)
                    .then(function (response) {
                        vm.inProgress = false;
                        if (response.data.response) {
                            vm.$notify({
                                message: vm.$t('cuentaCreadaCorrectamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                            vm.getSageBusinessData();
                            vm.getCuentasParaMostrar();
                            vm.getCuentasEspeciales();
                            vm.$modal.hide("modal-crear-cuenta");

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
            }

        },
        //Edita una cuenta
        editarCuenta() {

            //Se pasa E al estar editando al check campos
            if (this.checkCampos('E')) {
                this.inProgress = true;

                //Seteo el nuevo código de la cuenta
                this.listCuentas.forEach(cuenta => {
                    if (cuenta.id == this.cuentaAEditar.idCuenta) {
                        this.cuentaAEditar.codigoCuenta = cuenta.cuenta;
                    }
                })

                this.listCuentasProveedores.forEach(cuenta => {
                    if (cuenta.id == this.cuentaAEditar.idCuenta) {
                        this.cuentaAEditar.codigoCuenta = cuenta.cuenta;
                    }
                })

                this.listCuentasFormasPago.forEach(cuenta => {
                    if (cuenta.id == this.cuentaAEditar.idCuenta) {
                        this.cuentaAEditar.codigoCuenta = cuenta.cuenta;
                    }
                })

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };

                var params = {
                    id: this.cuentaAEditar.id,
                    codigoCuenta: this.cuentaAEditar.codigoCuenta,
                    codigoSubCuenta: this.cuentaAEditar.codigoSubCuenta,
                    idCuenta: this.cuentaAEditar.idCuenta,
                    nombreCuenta: this.cuentaAEditar.nombreCuenta,
                    tipo: this.cuentaAEditar.tipo,
                    proveedor: this.cuentaAEditar.idProveedor
                }

                let vm = this;
                this.axios.post(this.$store.getters.apiUrl + "importacion/editCuentaById", params, config)
                    .then(function (response) {
                        vm.inProgress = false;
                        if (response.data.response) {
                            vm.$notify({
                                message: vm.$t('cuentaEditadaCorrectamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                            vm.getSageBusinessData();
                            vm.getCuentasParaMostrar();
                            vm.getCuentasEspeciales();
                            vm.$modal.hide("modal-editar-cuenta");

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
            }
        },

        updateDatos() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            var params = {
                jwt: this.$store.getters.jwt,
                idTpv: this.idTpv,
                idBusiness: this.idBusiness,
                idCompany: this.idCompany,
                codigoEmpresa: this.negocio.empresa,
                codigoCanal: this.negocio.canal,
                codigoDelegacion: this.negocio.delegacion
            };

            let vm = this;
            this.axios.post(this.$store.getters.apiUrl + 'importacion/updateDatosSage', params, config)
                .then(function (response) {

                    if (response.data.response) {
                        vm.$notify({
                            message: vm.$t('datosActualizadosCorrectamente'),
                            icon: 'nc-icon nc-check-2',
                            timeout: 2000,
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'success'
                        });

                        vm.$router.go()
                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });

        },

        crearNuevaSageAccount() {
            if (this.checkCampos('NSA')) {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };

                var params = {
                    idTpv: this.idTpv,
                    codigo: this.newSageAccount.codigo,
                    nombre: this.newSageAccount.nombre,
                    tipo: this.newSageAccount.tipo,
                }

                let vm = this;
                this.axios.post(this.$store.getters.apiUrl + "importacion/newSageAccount", params, config)
                    .then(function (response) {
                        vm.inProgress = false;
                        if (response.data.response) {
                            vm.$notify({
                                message: vm.$t('cuentaCreadaCorrectamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                            vm.getSageBusinessData();
                            vm.getCuentasParaMostrar();
                            vm.getCuentasEspeciales();
                            vm.$modal.hide("modal-crear-sageaccount");

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
            }
        },
        editarSageAccount() {

            if (this.checkCampos('ESA')) {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };

                var params = {
                    idTpv: this.idTpv,
                    id: this.sageAccountToEdit.id,
                    codigo: this.sageAccountToEdit.codigo,
                    nombre: this.sageAccountToEdit.nombre,
                    tipo: this.sageAccountToEdit.tipo,
                }

                let vm = this;
                this.axios.post(this.$store.getters.apiUrl + "importacion/editSageAccount", params, config)
                    .then(function (response) {
                        vm.inProgress = false;
                        if (response.data.response) {
                            vm.$notify({
                                message: vm.$t('cuentaEditadaCorrectamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                            vm.getSageBusinessData();
                            vm.getCuentasParaMostrar();
                            vm.getCuentasEspeciales();
                            vm.$modal.hide("modal-editar-sageaccount");

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
            }
        },
        //Modal de borrar
        modalBorrarCuenta(id) {

            swal({
                title: this.$t('estaSeguroDeQueDeseaEliminarEstaCuenta'),
                text: this.$t('estaOperacionNoSePuedeDeshacer'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: this.$t('siBorrarCuenta'),
                cancelButtonText: this.$t('cancelar'),
                buttonsStyling: true
            }).then((result) => {
                if (result.value) {

                    this.deleteCuenta(id);

                }
            });

        },
        //Modal de edición
        showEditCuenta(id, nombreCuenta, codigoCuenta, codigoSubCuenta, tipo, idProveedor, idCuenta) {
            this.getCuentas()

            this.cuentaAEditar.id = id;
            this.cuentaAEditar.nombreCuenta = nombreCuenta;
            this.cuentaAEditar.codigoCuenta = codigoCuenta;
            this.cuentaAEditar.codigoSubCuenta = codigoSubCuenta;
            this.cuentaAEditar.tipo = tipo;
            this.cuentaAEditar.idProveedor = idProveedor;
            this.cuentaAEditar.idCuenta = idCuenta;

            this.$modal.show("modal-editar-cuenta");
        },
        //Modal de edición de sageaccounts
        showEditSageAccount(id, nombre, cuenta, tipo) {

            this.sageAccountToEdit.id = id;
            this.sageAccountToEdit.nombre = nombre;
            this.sageAccountToEdit.codigo = cuenta;
            this.sageAccountToEdit.tipo = tipo;

            this.$modal.show("modal-editar-sageaccount");
        },
        //Modal de creación
        openModal() {
            this.getCuentas();

            this.nuevaCuenta.nombre = '';
            this.nuevaCuenta.codigo = '';
            this.nuevaCuenta.codigoSubCuenta = '';
            this.nuevaCuenta.tipo = 'B';
            this.nuevaCuenta.idCuenta = '';

            this.$modal.show("modal-crear-cuenta");
        },
        //Modal de creación de proveedores
        openModalProveedores() {
            this.getCuentas();

            this.nuevaCuenta.nombre = '';
            this.nuevaCuenta.codigo = '';
            this.nuevaCuenta.codigoSubCuenta = '';
            this.nuevaCuenta.tipo = 'P'
            this.nuevaCuenta.idCuenta = '';

            this.$modal.show("modal-crear-cuenta");
        },
        //Modal de creación de formas de pago
        openModalFormasPago() {
            this.getCuentas();

            this.nuevaCuenta.nombre = '';
            this.nuevaCuenta.codigo = '';
            this.nuevaCuenta.codigoSubCuenta = '';
            this.nuevaCuenta.tipo = 'C'
            this.nuevaCuenta.idCuenta = '';

            this.$modal.show("modal-crear-cuenta");
        },

        //Modal para crear una cuenta de 3 dígitos (sageaccounts)
        openModalSageAccount() {
            this.newSageAccount.nombre = '';
            this.newSageAccount.codigo = '';
            this.newSageAccount.tipo = '';

            this.$modal.show("modal-crear-sageaccount");
        },
        openModalEspeciales() {
            //Aquí buscar las cuentas especiales y traerlas
            this.$modal.show("modal-cuentas-especiales");
        },
        //Modal de exportación de informe SAGE
        openModalSageExportacion() {
            this.$modal.hide("modal-producto-cuenta");
            this.$modal.show("modal-exportar-capte");
        },
        openModalSage200ExportacionFechas() {
            this.$modal.show("modal-exportar-sage200fecha");
        },
        //Modal para resetear días
        openModalResetearDias() {
            this.$modal.hide("modal-producto-cuenta");
            this.$modal.hide("modal-exportar-capte");
            this.$modal.show("modal-resetear-dias");
        },
        openModalProductssinCuenta() {
            this.$modal.show("modal-producto-cuenta");
        },
        closeModal() {
            this.$modal.hide("modal-editar-sageaccount");
            this.$modal.hide("modal-crear-cuenta");
            this.$modal.hide("modal-editar-cuenta");
            this.$modal.hide("modal-cuentas-iva");
            this.$modal.hide("modal-cuentas-especiales");
            this.$modal.hide("modal-crear-sageaccount");
            this.$modal.hide("modal-exportar-capte");
            this.$modal.hide("modal-producto-cuenta");
            this.$modal.hide("modal-resetear-dias");
            this.$modal.hide("modal-exportar-sage200fecha");
        },

    },
}
</script>
<style>
.theme-numier .vdatetime-calendar__month {
    height: 344.062px !important;
}

.theme-numier .vdatetime-year-picker__list,
.theme-numier .vdatetime-month-picker__list {
    height: 392.062px !important;
}

.tabCustom .active {
    background-color: white !important;
}

.tabCustom:hover {
    background-color: white !important;
    color: #2C6CF6;
}

.tabCustom:focus {
    background-color: white !important;
}

.tabsCustom {
    background-color: #f9f9f9 !important;
}

.tabs2Custom {
    background-color: #fcfcfc !important;
    width: 100%;
}

.contentStyle {
    margin-top: -16px;
}

#editTipoSageAccount:hover {
    color: #C0C4CC;
}
</style>
<style scoped>
tbody tr:hover {
    background-color: rgba(0, 153, 130, 0.2);
    cursor: pointer;
}

td div {
    padding: 12px 8px;
    color: #333;
}

.buttonsSearch:hover {
    cursor: pointer;
    background-color: rgba(0, 153, 130, 0.1);
}

.card {
    padding: 20px;
}

.input-group button {
    height: 40px;
}

.botonTotal {
    border: 1px solid #28a745;
    color: #FFFFFF;
    background-color: #28a745;
    font-weight: 400;
    padding: 8px 16px;
    /* cursor: pointer; */
    margin-bottom: 5px;
    font-size: 14px;
    line-height: 1.42857143;
}

.nombreProducto {
    color: #fff;
    background-color: #0e0e0e;
    text-shadow: 1px 1px #333;
    font-weight: 700;
    font-size: 15px;
}

.tituloPedido {

    color: #1E22AA;
    font-family: "Numier", "Helvetica Neue", Arial;
}

.my-custom-scrollbar {
    position: relative;
    height: 200px;
    overflow: auto;
}

.table-wrapper-scroll-y {
    display: block;
}

/*.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus {
        background-color: #FFFFFF;
    }*/

/*.bg-white:not(.active) {
    background-color: grey;
}*/
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Sage/ImportacionSage.vue